module.exports = __webpack_public_path__ + "static/media/compensar2.bbf52f9d.svg";